module.exports = __webpack_public_path__ + "static/media/mail.d0f4ff4e.svg";